module.exports = __webpack_public_path__ + "img/no-image.3c9ac1b0.jpg";